import { hasPluginPermission } from "utils";
import { Session } from "ezStore";
import { RelationFromQuery } from "../RelationDetails";

export enum RelationTabs {
	General = "general",
	WorkingHours = "workingHours",
	Contacts = "contacts",
	ShipManagerShips = "shipManagerShips",
	SkipperShips = "skipperShips",
	OperatorShips = "operatorShips",
	Locations = "locations",
	Products = "products",
	LinkedCustomers = "linkedCustomers"
}

export const showContactsTab = (relation: Pick<RelationFromQuery, "isCustomer" | "isOperator" | "isBroker" | "isSurveyor" | "isSkipper" | "isShipManager">): boolean => {
	return relation.isCustomer || relation.isOperator || relation.isBroker || relation.isSurveyor || relation.isSkipper || relation.isShipManager || false;
};

export const showContactRoleType = (relation: Pick<RelationFromQuery, "isCustomer" | "isBroker" | "isSurveyor">): boolean => {
	return relation.isCustomer || relation.isBroker || relation.isSurveyor || false;
};

export const showDefaultContact = (relation: Pick<RelationFromQuery, "isCustomer">): boolean => {
	return relation.isCustomer || false;
};

export const showVisibleForShip = (relation: Pick<RelationFromQuery, "isSkipper" | "isShipManager">): boolean => {
	return !relation.isSkipper && !relation.isShipManager;
};

export const showCommunicateStatusChanges = (relation: Pick<RelationFromQuery, "isOperator" | "isSkipper" | "isShipManager">, session: Session): boolean => {
	return hasPluginPermission(session, "useRelationsForStatusCommunication") && (relation.isOperator || relation.isSkipper || relation.isShipManager || false);
};

